import { makeAutoObservable } from 'mobx'
import { getDescendants } from '@minoru/react-dnd-treeview'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { TreeRootInboxes } from 'entities/Inbox'
import type { ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'
import { searchFilter } from 'pages/conversations/ui/ConversationMenu/lib/searchFilter'

export class SimpleMenuStore {
  private _search = ''
  private _loading = true

  constructor(
    private _conversationMenuStore: ConversationMenuStore,
    private _entities: IEntitiesStore
  ) {
    makeAutoObservable(this)
  }

  handleUpdateSearch = (value: string) => {
    this._search = value
  }

  fetchInboxesItems = async () => {
    this.setLoading(true)

    await this._entities.inboxesStore.fetchInboxes()

    const inboxes = this._entities.inboxesStore.personalInboxes

    this._conversationMenuStore.addItemsTree([...inboxes])

    this.setLoading(false)
  }

  setLoading = (value: boolean) => {
    this._loading = value
  }

  get loading() {
    return this._loading || this._entities.featureFlagsStore.loading
  }

  private get _selectInboxesSimpleFreeFilter() {
    if (!this._search) return this._conversationMenuStore.selectInboxesFreeSort

    return this._conversationMenuStore.selectInboxesFreeSort.filter((inboxTree) => {
      return searchFilter(inboxTree.data, this._search, this._entities)
    })
  }

  get items() {
    return getDescendants(this._selectInboxesSimpleFreeFilter, TreeRootInboxes.SIMPLE)
  }

  get search() {
    return this._search
  }

  get hideInboxes() {
    return this.items.length === 0 && this.search === ''
  }

  private get _selectInboxesFilter() {
    return this._entities.inboxesStore.personalInboxes
  }

  private get _selectInboxes() {
    return this._selectInboxesFilter.filter((item) => !item.isFavoriteType)
  }

  get selectInboxesCount() {
    return this._selectInboxes.map((item) => item.unread).reduce((state, value) => state + value, 0)
  }
}
